import classnames from 'classnames';
import * as React from 'react';
import { Icon } from '../icons/index.js';
import '../stack/index.js';
import { formMessage, kind, icon } from './form_message.css.js';
import { Stack } from '../stack/stack.js';

/**
 * Displays an inline message, usually used internally in form components.
 */
const FormMessage = ({ children, id, kind: kind$1 }) => {
    return (React.createElement(Stack, { className: classnames(formMessage, kind[kind$1]), gap: "small", alignItems: "center", wrap: false, id: id },
        kind$1 === 'error' && React.createElement(Icon, { name: "small-circular-cross", className: icon }),
        React.createElement("div", null, children)));
};

export { FormMessage };
